import { PrepaidWallet } from '@ancon/wildcat-types'

export type WalletPageParams = {
  walletId: string
}

export type WalletsReducerState = {
  /** Current Wallet Details */
  currentWalletDetails: PrepaidWallet | null

  /** Whether the top-up modal is visible */
  isWalletTopUpModalVisible: boolean

  /** Whether the wallet top-up checkout warning modal is visible */
  isWalletCheckoutWarningModalVisible: boolean
}

export type WalletTopUpFormState = {
  topUpAmount: string
}

export enum WalletCheckoutWarningType {
  WalletTopUp = 'walletTopUp',
  AddProducts = 'addProducts',
}
